import * as actiontype from "../actionType";
import { endPoints } from "../../utils/endPoints";
import { axiosInstanceWithUserToken } from "../../utils/Axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const getCategory = () => (dispatch) => {
    dispatch({ type: "LOADER" })
    axiosInstanceWithUserToken.get(endPoints.GET_CATEGORY)
        .then(response => {
            dispatch({ type: "LOADERSTOP" })
            dispatch({
                type: actiontype.GET_CATEGORY,
                payload: response.data.data
            })
        })
        .catch((errResponse) => {
            dispatch({ type: "LOADERSTOP" })
            // toast.error("error")
        });
};

